import { ApiClient } from "../api.client";
import {
  GetMeResponse,
  LoginRequest,
  LoginResponse,
  RefreshTokenRequest,
  RefreshTokenResponse,
} from "./types";
import {
  SetAdminPasswordRequest,
  SetAdminPasswordResponse,
} from "./types/set-admin-password.types";

const AuthApi = {
  login(body: LoginRequest) {
    return ApiClient.post<LoginRequest, LoginResponse>("/admins/login", body);
  },
  setAdminPassword({ accessToken, ...body }: SetAdminPasswordRequest) {
    return ApiClient.post<
      Omit<SetAdminPasswordRequest, "accessToken">,
      SetAdminPasswordResponse
    >("/admins/change-password", body, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  },
  refreshLogin(body: RefreshTokenRequest) {
    return ApiClient.post<RefreshTokenRequest, RefreshTokenResponse>(
      "/admins/refresh-token",
      body
    );
  },
  getMe() {
    return ApiClient.get<GetMeResponse>("/admins/me");
  },
};

export { AuthApi };
